import React from 'react';

import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';
import {
  RadioButton,
  RadioButtonPropsT,
} from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/form/radio-button.scss';

export type NcRadioButtonPropsT = RadioButtonPropsT & {
  unavailable?: boolean;
};
export type NcRadioButtonT = React.FC<NcRadioButtonPropsT>;

export const NcRadioButton: NcRadioButtonT = ({
  disabled,
  className,
  onChange,
  unavailable,
  ...props
}) => {
  const classNames = mergeClassNameStrings(
    className,
    mergeClassNameStrings('nc-radio-button', unavailable ? 'unavailable' : ''),
  );

  return (
    <RadioButton
      {...props}
      className={classNames}
      disabled={unavailable || disabled}
      onChange={(unavailable || disabled) ? undefined : onChange}
    />
  );
};
